import { render, staticRenderFns } from "./SignUpStepEmailChangeModal.vue?vue&type=template&id=752cc034"
import script from "./SignUpStepEmailChangeModal.vue?vue&type=script&lang=js"
export * from "./SignUpStepEmailChangeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports